<p-panel header="{{ 'change_password' | translate }}" *ngIf="!showCodeModal">
  <form [formGroup]="forgotPasswordForm" (submit)="onChangePassword()">
    <div class="ui-inputgroup">
        <span class="ui-inputgroup-addon"><i class="pi pi-user" style="line-height: 1.25;"></i></span>
        <input type="email" formControlName="email" pInputText placeholder="E-mail" style="width:100%">
    </div>
    <div
      class="errorMessage"
      *ngIf="forgotPasswordForm.invalid && f.email.touched && f.email.status === 'INVALID'"
      >{{ 'email_invalid' | translate }}</div>
    <div style="margin-top:10px;"></div>
    <div class="ui-inputgroup">
        <span class="ui-inputgroup-addon"><i class="pi pi-key" style="line-height: 1.25;"></i></span>
        <input type="password" formControlName="password1" pInputText placeholder="{{ 'new_password_one' | translate }}" style="width:100%">
    </div>
    <div style="margin-top:10px;"></div>
    <div class="ui-inputgroup">
        <span class="ui-inputgroup-addon"><i class="pi pi-key" style="line-height: 1.25;"></i></span>
        <input type="password" formControlName="password2" pInputText placeholder="{{ 'new_password_two' | translate }}" style="width:100%">
    </div>
    <div
      class="errorMessage"
      *ngIf="f.password1.touched && f.password2.touched && f.password1.value !== f.password2.value"
      >{{ 'passwords_not_same_error' | translate }}</div>
    <div style="margin-top:10px;"></div>
    <div style="text-align: center; width: 100%;">
      <button pButton type="submit" [disabled]="forgotPasswordForm.invalid || (f.password2.errors && f.password2.errors.mustMatch) || isLoading1" label="{{ 'change_password' | translate }}" class="ui-button-info" style="width: 100%;"></button>
    </div>
  </form>

  <app-loader *ngIf="isLoading1"></app-loader>
</p-panel>

<p-dialog
  header="{{ 'enter_forgot_password_code' | translate }}"
  [(visible)]="showCodeModal"
  [style]="{width: '50vw', top: '15vh'}"
  [baseZIndex]="10000"
  (onHide)="hideModal()">
  <div class="ui-g" >
    <div class="ui-g-3"></div>
    <div class="ui-g-6">
      <span class="ui-float-label">
        <input id="code-input" [(ngModel)]="code" type="text" pInputText style="width: 100%;">
        <label for="code-input">{{ 'enter_code_from_email' | translate }}</label>
      </span>
      <p *ngIf="codeError" class="errorMessage" style="margin-bottom: 0;">{{ 'invalid_code' | translate }}</p>
      <div style="height: 20px;"></div>
      <button pButton type="button" (click)="verifyCode()" [disabled]="isLoading2" label="{{ 'submit' | translate }}" class="ui-button-info" style="width: 100%;"></button>
    </div>
    <div class="ui-g-3"></div>

    <app-loader *ngIf="isLoading2"></app-loader>
  </div>
</p-dialog>
